<template>
  <!-- 作为港口auto-complete得下拉框样式模板 -->
  <div class="item-container">
    <div class="item-wrapper">
      <img v-if="detail.logo" class="logo" :src="detail.logo" alt />&ensp;
      <span class="text"
        >{{ detail.name ? detail.name + " " : "" }}({{
          detail.nameCn ? detail.nameCn + " | " : ""
        }}{{ detail.countryName }})</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
 },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.item-container {
  width: 100%;
  padding: 0 4px;
  height: 44px;
  margin-bottom: 4px;
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
  .item-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;
    overflow: hidden;
    transition: all 0.35s;
    &:hover {
      background-color: rgba(var(--theme-rgb), 0.1);
      border-radius: 6px;
      .text {
        color: var(--theme);
      }
    }
    .logo {
      flex: 0 0 auto;
      width: 22px;
      height: 16px;
      border-radius: 3px;
      margin-right: 12px;
    }
    .text {
      transition: all 0.35s;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 14px;
      font-weight: 400;
      color: #4a4a4b;
    }
  }
}
</style>
<style lang="scss">
.AutoPortTemplate-popover-tooltip {
  border-radius: 6px !important;
  padding: 4px 5px !important;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px #dbe0e7;

  border: 1px solid #ebeef5 !important;
  .popper__arrow {
    border: 1px solid #ebeef5 !important;
  }
}
</style>
